import { __assign } from "tslib";
import { getScreenStyles } from './layout';
import { getScreen } from './screen';
import { getHeaderAnnotations, getFooterAnnotations } from './annotation';
import { getHeaderHotspots, getFooterHotspots } from './hotspot';
import { getStatusBarUnderlayHeight } from './statusBar';
import { HEADER, FOOTER } from '../constants/screenLocation';
export function getHeaderProps(state, isCurrentScreen) {
    var screen = getScreen(state, isCurrentScreen);
    var screenStyles = getScreenStyles(state, isCurrentScreen);
    return __assign(__assign({}, _getHeaderProps(state, screen, screenStyles)), { marginLeft: screenStyles.imageMargin.marginLeft });
}
export function getFooterProps(state, isCurrentScreen) {
    var screen = getScreen(state, isCurrentScreen);
    var screenStyles = getScreenStyles(state, isCurrentScreen);
    return __assign(__assign({}, _getFooterProps(state, screen, screenStyles)), { marginLeft: screenStyles.imageMargin.marginLeft });
}
export function getOverlayHeaderProps(state, screenID, overlayWidth, overlayHeight, isCurrentScreen) {
    var screen = getScreen(state, screenID);
    var screenStyles = getScreenStyles(state, isCurrentScreen, screen, overlayWidth, overlayHeight);
    return _getHeaderProps(state, screen, screenStyles);
}
export function getOverlayFooterProps(state, screenID, overlayWidth, overlayHeight, isCurrentScreen) {
    var screen = getScreen(state, screenID);
    var screenStyles = getScreenStyles(state, isCurrentScreen, screen, overlayWidth, overlayHeight);
    return _getFooterProps(state, screen, screenStyles);
}
function _getHeaderProps(state, screen, screenStyles) {
    return __assign(__assign({}, _getCommonProps(screenStyles)), { type: HEADER, top: 0, height: screenStyles.headerHeight, backgroundPositionY: screenStyles.headerBackgroundOffset, header: screen.header, hotspots: getHeaderHotspots(state, screen), annotations: getHeaderAnnotations(state) });
}
function _getFooterProps(state, screen, screenStyles) {
    var statusBarTrimHack = getStatusBarUnderlayHeight(state);
    return __assign(__assign({}, _getCommonProps(screenStyles)), { type: FOOTER, bottom: 0, height: screenStyles.footerHeight + statusBarTrimHack, backgroundPosition: "left calc(100% - " + statusBarTrimHack + "px)", footer: screen.footer, hotspots: getFooterHotspots(state, screen), annotations: getFooterAnnotations(state) });
}
function _getCommonProps(screenStyles) {
    return {
        src: screenStyles.imgURL,
        width: screenStyles.imageWidth,
        backgroundImage: "url(" + screenStyles.imgURL + ")",
    };
}
